const STORAGE_KEY = 'nuxt-asset-recovery:reloaded';

/**
 * Stale HTML (CDN / in-app WebViews) can reference old `/_nuxt/` hashed chunks.
 * If a script or stylesheet from `/_nuxt/` fails to load, reload once to fetch fresh HTML.
 * Also handles dynamic import() failures (chunk errors) after deployments.
 */
export default defineNuxtPlugin((nuxtApp) => {
    const isNuxtAssetUrl = (url: string) => {
        try {
            const u = new URL(url, window.location.origin);
            return u.pathname.startsWith('/_nuxt/');
        } catch {
            return false;
        }
    };

    const reloadOnce = () => {
        if (sessionStorage.getItem(STORAGE_KEY) === '1') {
            return;
        }
        sessionStorage.setItem(STORAGE_KEY, '1');
        window.location.reload();
    };

    // Handle dynamic import() failures (e.g. "Failed to fetch dynamically imported module")
    nuxtApp.hook('app:chunkError', () => {
        reloadOnce();
    });

    // Handle <script>/<link> load failures
    window.addEventListener(
        'error',
        (event: Event) => {
            const target = event.target;
            if (!(target instanceof HTMLElement)) {
                return;
            }
            const url =
                target instanceof HTMLScriptElement
                    ? target.src
                    : target instanceof HTMLLinkElement && target.rel === 'stylesheet'
                      ? target.href
                      : '';
            if (!url || !isNuxtAssetUrl(url)) {
                return;
            }
            reloadOnce();
        },
        true,
    );
});
